import type { CSSProperties } from 'react'
import { useState } from 'react'

import Copy from '../../../public/copy.ico'
import { Button } from '../Button'
import { TextBox } from '../TextBox'
import { Window } from '../Window'

type Props = {
  title: string
  numberXLabel: string
  numberYLabel: string
  windowStyle?: CSSProperties
  getResult: (numberx: number, numbery: number) => number
}

export default function CalculatorWindow({
  title,
  windowStyle = { width: '250px' },
  numberXLabel,
  numberYLabel,
  getResult,
}: Props) {
  const [percentage, setPercentage] = useState('')
  const [targetNumber, setTargetNumber] = useState('')
  const result = getResult(
    Number.parseFloat(percentage),
    Number.parseFloat(targetNumber),
  )

  return (
    <Window
      title={title}
      showClose
      showMaximize
      showMinimize
      style={windowStyle}
    >
      <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
        <TextBox id="x-percent" label={numberXLabel} onChange={setPercentage} />
        <TextBox
          id="y-number"
          label={numberYLabel}
          onChange={setTargetNumber}
        />
        <Window
          title="result.exe"
          style={{
            alignSelf: 'flex-end',
            height: '55px',
            width: '100px',
            userSelect: 'text',
          }}
        >
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
              gap: '8px',
            }}
          >
            <input
              type="text"
              readOnly
              value={Number.isNaN(result) ? '' : String(result)}
              style={{ flex: 1, minWidth: 0, height: '20px' }}
            />
            <Button
              style={{
                minWidth: '17px',
                width: '17px',
                minHeight: '17px',
                height: '17px',
                paddingRight: '0px',
                paddingLeft: '0px',
              }}
              onClick={() => {
                void navigator.clipboard.writeText(String(result))
              }}
            >
              <img
                src={Copy}
                style={{
                  width: '15px',
                }}
              />
            </Button>
          </div>
        </Window>
      </div>
    </Window>
  )
}
